import EmptyState from "./empty-state"
import { Button } from "@workspace/web-ui/components/button"

export default function EncountersDetailsPrescription({prescriptions}:{prescriptions:any}) { 
  console.log('prescriptions',prescriptions.data)
  if (!prescriptions.data.prescriptions || prescriptions.data.prescriptions.length === 0) {
    return (
      <div className="flex flex-col gap-[8px] px-[16px]">
        <EmptyState title="No Prescription Yet" message="To receive a prescription, you’ll need to complete a consultation." type="prescription" />
      </div>
    );
  }
  return (
        <div className="flex flex-col gap-[8px] px-[16px]">
           {prescriptions.data.prescriptions.map((prescription:any, index:number) => (
             <div key={index} className="border   border-[#0404041A] rounded-[12px] p-[16px] flex justify-between ">
                <div className="flex flex-col gap-[8px]">
                <h1 className="text-[#1A202C] text-[16px] font-medium leading-[137%] tracking-[-1%]">{prescription?.medication?.name}</h1>
                <div className="flex flex-col gap-[8px]">
                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]"> Dosage: {prescription?.medication?.dosage}</span>
                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]"> Duration: {prescription?.medication?.duration}</span>
                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Frequency: --</span>
                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Price: ${prescription?.medication?.cost}</span>
                  <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Payment Status: <span className={`font-medium capitalize ${prescription?.payment_status === 'paid'?'text-[#00C781]':'text-[#464B55]'}  `}> {prescription?.payment_status.replace(/_/g,' ')}</span></span>
                  <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Delivery Status:<span className={`font-medium text-[#00C781] capitalize ${prescription?.delivery_status === 'delivered'?'text-[#00C781]':'text-[#464B55]'} `}> {prescription?.delivery_status}</span></span>
                  <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Instructions: <span>--</span></span>
                </div>
                 </div>         
            </div>
          ))}
          <Button variant="outline"  className="border-[#DCDCDE]   h-auto w-full text-[#464B55] !py-[12px] !px-[16px] rounded-[10px]">
             Pay for medication - $0.00
          </Button>
        </div>
  )
}